module.exports = __webpack_public_path__ + "static/media/decline_trade.fa696be4.svg";